<app-navigation
    [additionalContainerClasses]="[]"
    [automaticFooterPadding]="false">
    <app-user-register-detail></app-user-register-detail>
</app-navigation>
